<template>
  <div>
    <div>
      平台发票
    </div>
    <div class="content">
      <div class="radopGroupDiv">
          <el-radio-group v-model="activeName" @change="handleClick">
            <el-radio-button label="top" >开具发票</el-radio-button>
            <el-radio-button label="right" class="handleClick">开票记录</el-radio-button>
          </el-radio-group>
        </div>
      <!-- 开票记录 -->
      <div>
        <successListTabel></successListTabel>
      </div>
    </div>

  </div>
</template>
<script>
import successListTabel from '@/components/invoice/successListTabel.vue'
  export default {
    components: {
      successListTabel
    },
    data() {
      return {
        activeName: 'right'
      };
    },
    methods: {
      handleClick(tab, event) {
        this.$router.push({
          name: "const-center-my-invoice"
        });
      }
    }
  };
</script>

<style lang="scss" scoped>
.content{
  padding: 20px;
  background: #FFFFFF;
  margin-top: 10px;

}
::v-deep .radopGroupDiv{
  border-bottom: 1px solid #E5E8ED;
  .handleClick {
    .el-radio-button__orig-radio:checked + .el-radio-button__inner{
      background: #066eb71a !important;
      // border: 1px solid #066EB7;
      color: #066EB7;
      border-color: #066EB7;
    }
  }
}
.tips{
  margin-top: 20px;
  background: #F5F7FA;
  padding: 24px 31px;
  font-family: SourceHanSansCN-Regular;
  font-weight: 400;
  font-size: 14px;
  color: #4F5D78;
}
</style>